import { View } from "binder"
import { StopReason, StopReasonManipulationViewModel } from "./stopReasonManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class StopReasonManipulationView extends View<StopReasonManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-6B5C80C0-776A-4828-BCB5-75F98704535E"
    }
    loadHtml(): string {
        let element = require('./stopReasonManipulation.html').default;
        let style = require('./stopReasonManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set stopReasons(v: StopReason) { this._stopReasons = v; } public get stopReasons(): StopReason { return this._stopReasons; } private _stopReasons: StopReason;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
